const multiplePaymentsColumns = [
    {
        Header: 'Customer name' /*Payer Name*/,
        accessor: 'customerName' /*beneficiaryName*/,
    },
    {
        Header: 'Currency' /*Currency*/,
        accessor: 'instructedCurrency' /* tnxCurrency*/,
    },
    {
        Header: 'Amount' /*Amount*/,
        accessor: 'instructedAmount' /*tnxAmount*/,
    },
    {
        Header:
            "Payment reference" /*Payer's Transaction Reference*/,
        accessor: 'custBeneInfo' /* uniqueIdentifier*/,
    },
];

export default multiplePaymentsColumns;
